import React, { EventHandler, MouseEvent } from "react";
import { ArrowRight, Layers, X } from "react-feather";

interface CardProps {
  hideInstructions: EventHandler<MouseEvent>;
}

const Card: React.FC<CardProps> = ({ hideInstructions }) => {
  return (
    <div className="card">
      <div className="upper">
        <X className="close" onClick={hideInstructions} />
        <h2>Tabs & Map Access</h2>
        <div className="icons">
          <Layers className="blue" />
          <ArrowRight />
          <Layers />
        </div>
        <p>The Layers tab is initially toggled on. To show full map press the active icon.</p>
      </div>
      {/* Pager was originally here */}
    </div>
  )
}

export default Card;